module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("There are in fact a number of words from languages in this group which have entered English by way of other European languages, especially French; in these cases the combinations of letters must be pronounced according to the spelling conventions of the language concerned. In "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("couscous")]), _vm._v(" and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("souk")]), _vm._v(" the combination "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("ou")]), _vm._v(" must be pronounced as in French (that is, like English "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("oo);")]), _vm._v(" in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("comitadji")]), _vm._v(" and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("djibbah")]), _vm._v(" the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("dj")]), _vm._v(" is to be pronounced like English "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("j")]), _vm._v("; and so on. Occasionally the standard form combines elements from a French and an English transliteration: in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("djinnee,")]), _vm._v(" for instance, the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("dj")]), _vm._v(" is French and the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("ee")]), _vm._v(" is English. In none of these cases is any doubt or difficulty likely to arise in practice.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Words from Russian present a few special problems. The more recent adoptions normally appear in a sensible transliteration which is more or less self-explanatory: consonants and consonant groups are pronounced as in English, vowels as in Italian. In such a word as "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("dacha,")]), _vm._v(" for instance, the two "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("a")]), _vm._v("’s have their ‘Continental’ value, but "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("ch")]), _vm._v(" is to be pronounced as in English, not as in French or as in German. Some difficulty arises with the Russian character properly transliterated "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("shch,")]), _vm._v(" since this awkward collocation of consonants tends to be avoided in English. Russian "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("borshch")]), _vm._v(" normally appears as "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("bortsch")]), _vm._v(" in English, Russian "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("yamshchik")]), _vm._v(" as "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("yamschik")]), _vm._v(" or "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("yamstchik")]), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/07_Introduction_2#A29",
      "id": "B29"
    }
  }, [_vm._v("1")])]), _vm._v(". The accepted English spelling of some of the earlier borrowings from Russian retains vestiges of the spelling-systems of other European languages through which they have passed: in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("moujik,")]), _vm._v(" for instance, the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("ou")]), _vm._v(" and the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("j")]), _vm._v(" have to be pronounced as in French; a more modern transliteration would be "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("muzhik.")]), _vm._v(" The most irrational spelling of all is to be found in the word "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("czar,")]), _vm._v(" from Russian "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("tsarĭ,")]), _vm._v(" and efforts have been made (without conspicuous success) to substitute the spelling "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("tsar,")]), _vm._v(" which certainly represents the Russian pronunciation much more accurately. One obstacle in the way of this reform is the existence of the form "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("czarina")]), _vm._v(" as the accepted English name for the wife of a "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("czar.")]), _vm._v(" This word has a curious history: it is formed from "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("czar")]), _vm._v(" (itself an obsolete German transliteration of the Russian word) by the addition, first of the German feminine ending "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("-in,")]), _vm._v(" then of the Italian feminine ending "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("-a.")]), _vm._v(" Purists are obliged to insist on the substitution of the true Russian feminine form "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("tsaritsa;")]), _vm._v(" and since the public is naturally unwilling to accept an innovation which involves "), _c('a', {
    attrs: {
      "id": "page_46"
    }
  }), _vm._v("a radical change of pronunciation, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("czarina")]), _vm._v(" still holds the field and has tended to reinforce the tenacity of the spelling "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("czar.")])]), _vm._v(" "), _c('h4', {
    staticClass: "head2",
    attrs: {
      "id": "id25"
    }
  }, [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE SPELLING OF")]), _vm._v(" E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UROPEAN LANGUAGES")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("In general the spelling of words and phrases introduced into English from European languages is the spelling current in the language of origin. However, there are a number of exceptions to this rule; some are justified either by long usage or by common sense, others are due either to ignorance or to carelessness, and ought to be discouraged. Many of the traditional divergences from contemporary foreign usage have been discussed above, "), _c('a', {
    attrs: {
      "href": "#/xhtml/05_Introduction#page_11"
    }
  }, [_vm._v("pp. 11")]), _vm._v("–"), _c('a', {
    attrs: {
      "href": "#/xhtml/05_Introduction#page_12"
    }
  }, [_vm._v("12")]), _vm._v(". The preservation of obsolete foreign spellings in English is justified partly by reverence for tradition, partly by considerations of expediency. English "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("duenna,")]), _vm._v(" for example, preserves the older spelling of Spanish "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("dueña;")]), _vm._v(" the older spelling must obviously be retained, since "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("dueña")]), _vm._v(" would conflict with the English pronunciation of the word. English "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("foible")]), _vm._v(" preserves the older spelling of French "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("faible;")]), _vm._v(" any interference with the traditional spelling "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("foible")]), _vm._v(" would not only conflict with the English pronunciation but would lead to confusion between two distinct words, since the Modern French "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("faible")]), _vm._v(" has been introduced into English in a different sense. In other cases, too, the adoption of a current foreign spelling is ruled out by the English pronunciation. French "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("avant-coureur,")]), _vm._v(" for instance, appears in English as "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("avant-courier,")]), _vm._v(" in which the second element (but not the first) has been anglicized"), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/07_Introduction_2#A30",
      "id": "B30"
    }
  }, [_vm._v("1")])]), _vm._v("; restoration of the French spelling would conflict with the accepted pronunciation. The English form "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("pistachio")]), _vm._v(" appears to be a compromise between the Spanish "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("pistacho")]), _vm._v(" and the Italian "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("pistacchio;")]), _vm._v(" the accepted pronunciation is based on that of the Spanish form but is not identical with it, so that any change of spelling would be inappropriate"), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/07_Introduction_2#A31",
      "id": "B31"
    }
  }, [_vm._v("2")])]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The use of accent-marks and other diacritics in words and phrases of foreign origin presents a special problem. The difficulty here is in part merely typographical: many of the founts used in printing "), _c('a', {
    attrs: {
      "id": "page_47"
    }
  }), _vm._v("popular newspapers are deficient in the special characters required,"), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/07_Introduction_2#A32",
      "id": "B32"
    }
  }, [_vm._v("1")])]), _vm._v(" so that the printers have no choice but to omit the accent-marks; and the appearance of a word without an accent-mark may become so familiar that the accent-mark is omitted even when a special character is available. The lack of a suitable special character may account for the rarity of the Scandinavian symbol "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("ø")]), _vm._v(" in such words as Danish "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("smørrebrød")]), _vm._v("; the fact that Swedish uses "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("ö")]), _vm._v(" where Norwegian uses "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("ø")]), _vm._v(" encourages the use of the more familiar and more easily obtainable "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("ö")]), _vm._v(", so that the spelling "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("smörrebröd")]), _vm._v(" is not uncommon. In this particular instance the largely accidental resemblance to Norwegian "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("smørgåsbord,")]), _vm._v(" Swedish "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("smörgåsbord,")]), _vm._v(" may have something to do with the substitution. In the same way "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("skijöring")]), _vm._v(" has become the accepted English spelling of Norwegian "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("skikjøring")]), _vm._v(" (the omission of the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("k")]), _vm._v(" is doubtless due to the fact that Norwegian "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("k")]), _vm._v(" is very lightly pronounced in such a position).")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("However, peculiarities in the use of accent-marks are not wholly to be accounted for by a lack of suitable special characters. Certain accent-marks seem to be highly acceptable to English taste, and are rarely omitted; some may even be inserted where they are not called for. German words which call for the use of the diæresis ¨ are rarely printed without it, though "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Fräulein")]), _vm._v(" occasionally appears as "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Fraulein,")]), _vm._v(" probably through confusion with "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Frau;")]), _vm._v(" the diæresis is never omitted from French "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("naïf,")]), _vm._v(" though curiously enough it is often omitted from the feminine "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("naïve.")]), _vm._v(" The French circumflex accent ˆ is also relatively stable. It would be mere pedantry to insist on "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("châssis")]), _vm._v(" and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("hôtel")]), _vm._v(" (though "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("hôtelier")]), _vm._v(" is still very common); "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("bâton")]), _vm._v(" in some of its more common senses normally drops the circumflex; "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("rêverie,")]), _vm._v(" too, is very frequently written without the circumflex. However, such common word as "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("dépôt, entrepôt")]), _vm._v(" and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("rôle")]), _vm._v(" still very generally retain it; perhaps the commonest spelling of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("dépôt")]), _vm._v(" is "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("depot,")]), _vm._v(" without the acute but with the circumflex accent. What is rather surprising is the fact that in a large number of words the circumflex accent is either substituted for another accent-mark or introduced without any justification in French. The circumflex is sometimes substituted for the acute accent ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("crêpon")]), _vm._v(" for "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("crépon")]), _vm._v(") or for the grave accent ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("crêche, crême de la crème")]), _vm._v(" for "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("crèche, crème de la crème")]), _vm._v("); in a great many cases it is introduced "), _c('a', {
    attrs: {
      "id": "page_48"
    }
  }), _vm._v("without any justification at all ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("châlet, chênet, compôte, côterie, rôturier")]), _vm._v(" for "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("chalet, chenet, compote, coterie, roturier")]), _vm._v(")"), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/07_Introduction_2#A33",
      "id": "B33"
    }
  }, [_vm._v("1")])]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The least stable of the accent-marks is the acute accent in words of French origin. Here the stability depends to a large extent on the position of the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("é")]), _vm._v(" in the word. The omission of the accent-mark from "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("é")]), _vm._v(" at the end of a word could easily lead to mispronunciation, and there are in English use many pairs of French words distinguished only by the presence or absence of the acute accent: "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("comble")]), _vm._v(" and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("comblé, gêne")]), _vm._v(" and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("gêné, manque")]), _vm._v(" and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("manqué,")]), _vm._v(" and others. The omission of the acute accent from a word like "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("communiqué")]), _vm._v(" would lead to confusion with words like "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("critique")]), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/07_Introduction_2#A34",
      "id": "B34"
    }
  }, [_vm._v("2")])]), _vm._v(". So important is this final "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("-é,")]), _vm._v(" in fact, that it is sometimes reinforced by an additional, unetymological, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("e,")]), _vm._v(" as in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("rechauffée, soufflée")]), _vm._v(" for "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("rechauffé, soufflé;")]), _vm._v(" we have already seen ("), _c('a', {
    attrs: {
      "href": "#/xhtml/05_Introduction#page_12"
    }
  }, [_vm._v("p. 12")]), _vm._v(") that final "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("-ée")]), _vm._v(" is sometimes preferred to other French endings in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("couchée, levée")]), _vm._v(" and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("toupée.")]), _vm._v(" At the beginning of a word "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("é")]), _vm._v(" is relatively stable when it is followed by only one consonant, since there are few English words beginning with "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("e")]), _vm._v(" and a single consonant: such words as "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("élan, élite, épergne, étape, étude")]), _vm._v(" rarely lose the acute accent. But when "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("e")]), _vm._v(" at the beginning of a word is followed by two consonants, as in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("éclair, éclat, écru, épris, étrier")]), _vm._v(" and other words, omission is much more common. Most vulnerable of all is "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("é")]), _vm._v(" preceded by a single consonant, as in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("débris, début, décor, dépôt, réclame, régime, répertoire, résumé;")]), _vm._v(" in such words the acute accent is perhaps more often omitted than not. Occasionally an overanxiety for correctness in words of this type may lead to the addition of an acute accent where none is called for, as in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("récherché")]), _vm._v(" for "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("recherché.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It must not be overlooked that frequency of usage has something to do with the use and disuse of accent-marks. The words in which accent-marks are most commonly omitted are those which are most commonly used; the spelling of less frequent words, especially of technical or quasi-technical words, tends to conform fully to that of the language from which they come.")]), _vm._v(" "), _c('h4', {
    staticClass: "head2",
    attrs: {
      "id": "id26"
    }
  }, [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE PRONUNCIATION OF")]), _vm._v(" E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UROPEAN LANGUAGES")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The question of the pronunciation of words and phrases from modern European languages is a very thorny one. The basis of the difficulty "), _c('a', {
    attrs: {
      "id": "page_49"
    }
  }), _vm._v("is the fact that the sounds of what is often called ‘Received Standard English’ differ very substantially from those of most European languages. In particular, Standard English makes extensive use of diphthongs and contains relatively few pure vowels, so that the pronunciation of the pure vowels so common in most European languages does not come easily to the speaker of Standard English. From this point of view the speaker of dialectal English, or of one of the Regional Standards, is at an advantage over the speaker of Standard English, since the dialects use many pure vowels never heard in Standard English. There is a further difficulty which affects all speakers of English more or less equally: many European languages make use of sounds unknown either in Standard English or in the dialects. The French nasal vowels, for instance, are never used in any form of English; the ‘front rounded’ vowels "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("ö")]), _vm._v(" and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("ü")]), _vm._v(" are not used in Standard English, and are rare in the dialects"), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/07_Introduction_2#A35",
      "id": "B35"
    }
  }, [_vm._v("1")])]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It follows that the pronunciation of a ‘foreign’ word or phrase in an English sentence exactly as it is pronounced in its language of origin will require the use of a number of sounds not used in the rest of the discourse. The achievement of such a pronunciation is exceedingly difficult, even for a speaker who knows the language in question really well; it is undesirable, since it interrupts the natural flow of discourse—the listener will be temporarily more occupied in admiring a feat of lingual agility than in following the meaning of the sentence; and it is above all unnecessary—it can serve no useful purpose to pronounce a ‘foreign’ expression in an English sentence with a perfect native accent. (Speakers who attempt such feats are commonly those who will use ‘foreign’ expressions merely for the sake of conveying an impression of their superior culture and erudition.) On the other hand, complete anglicization of pronunciation is equally undesirable. We have already seen ("), _c('a', {
    attrs: {
      "href": "#/xhtml/05_Introduction#page_21"
    }
  }, [_vm._v("pp. 21")]), _vm._v("–"), _c('a', {
    attrs: {
      "href": "#/xhtml/06_Introduction_1#page_25"
    }
  }, [_vm._v("25")]), _vm._v(") that there are many excellent reasons why certain words and phrases have remained ‘foreign’ instead of being anglicized, and it is important that such expressions should be recognizable as ‘foreign’ in speech as well as in writing"), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/07_Introduction_2#A36",
      "id": "B36"
    }
  }, [_vm._v("2")])]), _vm._v(". What is required, therefore, is a pronunciation which will not be so far removed from that of English as to stand out abruptly from its context, yet which will be sufficiently distinctive to ensure that the expression concerned can be readily recognized as ‘foreign’.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_50"
    }
  }), _vm._v("There are certain characteristics shared by many foreign languages but not by English which can be called into play to achieve the desired effect. The most important of these is the general tendency in languages other than English to pronounce unstressed vowels distinctly, instead of slurring them and obscuring their quality as in English; by pronouncing unstressed vowels in ‘foreign’ expressions distinctly, the speaker of English can mark these expressions out as ‘foreign’ without making use of any sound which does not occur in English. Another characteristic, most noticeable in French but discernible in some other languages, is a tendency to place the stress in a position different from that which would seem most natural in English. The reproduction of these two characteristics will be sufficient to distinguish as ‘foreign’ a great many words and phrases—though obviously neither is applicable to monosyllabic words of foreign origin. Such words as "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("étagère")]), _vm._v(" and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("jalousie,")]), _vm._v(" for instance, can be marked out as ‘foreign’ without the use of any foreign sounds by placing the stress on the last syllable and pronouncing the unstressed vowels clearly and distinctly. In precisely the same way the technical term "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("caractère")]), _vm._v(" can be distinguished from English ‘character’ without the use of any foreign sounds; to attempt to reproduce the French ‘"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("r grasseyé’")]), _vm._v(" twice over would make the word unnecessarily conspicuous in its context.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("For the rest, the pronunciation of individual vowels and consonants depends to a certain extent on the nature of the expression concerned and on the context in which it is used. The more technical an expression, the stronger the tendency to reproduce with some accuracy its pronunciation in the language from which it comes; less technical expressions, especially those in frequent use, should be pronounced with as few foreign sounds as possible. When pronouncing expressions of this latter kind the prudent speaker will avoid pedantry or eccentricity and aim at a simple, natural effect. Whenever an English sound provides a reasonable approximation to a foreign sound he will substitute it for the foreign sound; whenever there is no reasonable English equivalent to a foreign sound he will imitate the foreign sound as closely as is consistent with the general pattern of English sounds. He will, for instance, in general substitute an English vowel-sound (impure or diphthongal though it may be) for a foreign vowel-sound, and ignore minor differences in the pronunciation of the consonants; but he will produce an unostentatious approximation to, say, the nasal vowels of French, the ‘front rounded’ vowels "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("ö")]), _vm._v(" and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("ü,")]), _vm._v(" or the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("ch")]), _vm._v("-sounds of German. In some cases linguistic discretion will suggest an even more extensive substitution of English sounds: the phrase "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("hors d’œuvre,")]), _vm._v(" for instance, is pronounced without any foreign sounds "), _c('a', {
    attrs: {
      "id": "page_51"
    }
  }), _vm._v("at all—no ‘front rounded’ vowel is normally attempted in the second word.")]), _vm._v(" "), _c('h4', {
    staticClass: "head2",
    attrs: {
      "id": "id27"
    }
  }, [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE USE OF FOREIGN FEMININE FORMS IN")]), _vm._v(" E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NGLISH")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("A great many foreign languages preserve a more extensive system of genders than English does: whereas with few exceptions English preserves a distinction of gender only in the pronouns of the third person singular, in many languages the distinction extends throughout the inflection of nouns and adjectives. No attempt is ever made in English to imitate the grammatical gender of a foreign language when a ‘foreign’ adjective is used—that is, the form of the adjective is never adjusted to suit the grammatical gender (in the language from which the adjective comes) of the noun which it qualifies—but it is normal to adjust the form of ‘foreign’ nouns and adjectives to suit the feeling for natural gender in English. Special feminine forms are therefore used only with ‘foreign’ nouns referring to persons, or with ‘foreign’ adjectives which in their English context happen to refer to persons.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("By far the most numerous special feminine forms are to be found amongst words of French origin, and these are in general used correctly. A great many French adjectives used in English are formed from past participles: "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("accablé, borné, déclassé, déséquilibré, distingué, empressé, froissé, maquillé, passé, soigné")]), _vm._v(" and numerous others. The feminine of these is formed by adding an "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("e")]), _vm._v(" which does not affect the pronunciation, and it is perhaps because the pronunciation is not affected that the omission of the final "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("-e,")]), _vm._v(" though not common, is more frequent than with most other types of French adjective. When an adjective of this type is used as a noun the omission of the feminine "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("-e")]), _vm._v(" is much more common: "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("habitué")]), _vm._v(" and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("protégé")]), _vm._v(" are as often as not left uninflected when they refer to women. When the pronunciation of the feminine differs from that of the masculine the neglect of the special feminine form is very rare. Various regular types can be distinguished. (1) Adjectives formed from present participles in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("-ant,")]), _vm._v(" feminine "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("-ante (clairvoyant, exigeant, intransigeant, piquant);")]), _vm._v(" with these may be included "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("méchant,")]), _vm._v(" though it is no longer felt as a present participle in French. (2) Nouns (and a few adjectives) formed with the agent-suffix "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("-eur,")]), _vm._v(" feminine "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("-euse (charmeur, chauffeur, coiffeur, danseur, enjôleur, entrepreneur, farceur, poseur, siffleur, souffleur")]), _vm._v("); with these may be classed adjectives in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("-eux,")]), _vm._v(" feminine "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("-euse (précieux, sérieux).")]), _vm._v(" (3) Other French nouns and adjectives in which the feminine differs in pronunciation from the masculine: "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("bourgeois (bourgeoise), épris (éprise), gamin (gamine), mesquin")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_52"
    }
  }), _vm._v("("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("mesquine), métis (métisse), mignon (mignonne), naïf (naïve), roturier (roturière), sournois (sournoise);")]), _vm._v(" the oddity here is "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("naïf,")]), _vm._v(" since the feminine "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("naïve")]), _vm._v(" is often used in preference to the masculine even when it refers to a male person. Italian and Spanish nouns and adjectives ending in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("-o")]), _vm._v(" form their feminine by changing "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("-o")]), _vm._v(" into "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("-a,")]), _vm._v(" and this adjustment is usually carried out in English with such words as "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("aficionado, beato, contadino, majo, mestizo, simpatico.")]), _vm._v(" There are two exceptions: though feminine forms are sometimes used in English, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("incognito")]), _vm._v(" and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("incommunicado")]), _vm._v(" are often left unchanged in such sentences as ‘she was travelling "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("incognito’")]), _vm._v(" and ‘she was held "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("incommunicado")]), _vm._v(" by the police’, doubtless because the words are felt to be adverbial rather than adjectival in such sentences. Another exception, this time in French, is to be found in the phrase "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("nouveau riche")]), _vm._v(": the feminine "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("nouvelle riche")]), _vm._v(" is exceedingly rare, doubtless because the phrase is felt to mean ‘newly rich’, with "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("nouveau")]), _vm._v(" in an adverbial function. Phrases sometimes offer a little difficulty, since more than one word may need to be put into the feminine form: "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("croyant et pratiquant (croyante et pratiquante), faux dévot (fausse dévote), petit bourgeois (petite bourgeoise), premier danseur (première danseuse).")]), _vm._v(" Another kind of difficulty is offered by "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("enfant chéri,")]), _vm._v(" feminine "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("enfant chérie—")]), _vm._v("the first word remains unchanged.")]), _vm._v(" "), _c('h4', {
    staticClass: "head2",
    attrs: {
      "id": "id28"
    }
  }, [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE USE OF FOREIGN PLURALS IN")]), _vm._v(" E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NGLISH")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The question of foreign plurals is much more complicated. There are in general no English feminines to compete with the foreign feminines, so that the only question which arises is whether the foreign feminine is used or not; but any ‘foreign’ word can with a little difficulty be fitted with an English plural, so that either an English or a foreign plural may be used; certain words sometimes take an English plural, sometimes a foreign one. Words from little-known languages nearly always take an English plural—no doubt because the correct foreign plural is unknown to most of those who use the words. A few such words, however, mostly technical, generally take a foreign plural: Welsh "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("cynghanedd (cynganeddion")]), _vm._v(") and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("eisteddfod (eisteddfodau),")]), _vm._v(" Arabic "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("fellah (fellahin")]), _vm._v(") and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("hadith (hadithat),")]), _vm._v(" Hebrew "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("kibbutz (kibbutzim),")]), _vm._v(" Russian "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("izvoschik (izvoschiki), stilyaga (stilyagi")]), _vm._v(") and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("zastruga (zastrugi).")]), _vm._v(" In the case of Classical words and words from the more familiar modern languages the correct plural is widely known, or can easily be ascertained, and the difficulty is to know whether it should be used or not.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The majority of Latin masculines in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("-us")]), _vm._v(" form their plural in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("-i,")]), _vm._v(" and this rule is very generally observed in English, probably because of "), _c('a', {
    attrs: {
      "id": "page_53"
    }
  }), _vm._v("the awkwardness of an ending "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("-uses: bacillus, caduceus, modulus, papyrus, stylus,")]), _vm._v(" and a great many others. However, there are some traps for the unwary. Certain fourth-declension nouns in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("-us")]), _vm._v(" remain unchanged in the plural: "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("apparatus, excursus, fœtus, ictus, tractatus—")]), _vm._v("though the use of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("apparati")]), _vm._v(" is not unknown amongst scientists. Other nouns in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("-us")]), _vm._v(" were originally verbs in the first person plural, and with these there is no alternative to the awkward "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("-uses: ignoramus, inspeximus, mandamus, vidimus.")]), _vm._v(" A trap of a different kind is to be found in the word "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("polypus,")]), _vm._v(" which has plural "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("polypi")]), _vm._v(" although something like "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("polypodes")]), _vm._v(" might have been expected. The few Greek nouns which retain the singular "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("-os")]), _vm._v(" form their plural in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("-oi")]), _vm._v(" instead of the rather awkward "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("-oses,")]), _vm._v(" which would in any case be liable to confusion with the plural of nouns in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("-osis: kouros, pithos, stichos.")]), _vm._v(" Latin neuters in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("-um")]), _vm._v(" regularly form their plural in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("-a")]), _vm._v(" in English, because of the awkwardness of an ending "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("-ums: addendum, bacterium, consortium, curriculum, datum, desideratum, memorandum, quinquennium, stratum, ultimatum.")]), _vm._v(" A few nouns like "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("fulcrum")]), _vm._v(" do have a plural in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("-ums,")]), _vm._v(" and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("medium")]), _vm._v(" has two plurals "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("media")]), _vm._v(" and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("mediums,")]), _vm._v(" differentiated according to the meaning. Greek neuters in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("-on")]), _vm._v(" more often than not form their plural in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("-a: acroterion, criterion, ganglion, megaron, noumenon, phenomenon, prolegomenon.")]), _vm._v(" However, the ending "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("-ons")]), _vm._v(" is much less objectionable than "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("-ums")]), _vm._v(" because it is familiar in the very numerous, fully anglicized words ending in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("-ation, -ition,")]), _vm._v(" etc., so that although "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("phenomenons")]), _vm._v(" and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("prolegomenons")]), _vm._v(" are unthinkable, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("criterions")]), _vm._v(" and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("ganglions")]), _vm._v(" are sometimes preferred to "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("criteria")]), _vm._v(" and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("ganglia.")]), _vm._v(" The use of the Latin plural of feminines in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("-a")]), _vm._v(" is much less frequent, and with many such nouns a plural in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("-as")]), _vm._v(" is much more frequent than the Latin plural in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("-æ: abscissa, amphora, cicada, lamina, nebula—")]), _vm._v("only in a highly technical context is a plural in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("-æ")]), _vm._v(" to be expected. On the other hand such words as "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("differentiae")]), _vm._v(" and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("sequelae")]), _vm._v(" are so much better known in the plural than in the singular that the use of any other plural is unlikely.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The less common Greek and Latin plurals tend to be avoided. The plurals "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("lemmata, oedemata, traumata")]), _vm._v(" and the like are giving place to "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("lemmas, oedemas, traumas.")]), _vm._v(" Though "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("ambo")]), _vm._v(" still has a plural "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("ambones, cento")]), _vm._v(" prefers "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("centos")]), _vm._v(" to "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("centones.")]), _vm._v(" So also "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("calx")]), _vm._v(" and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("vortex")]), _vm._v(" tend to prefer "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("calxes")]), _vm._v(" and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("vortexes")]), _vm._v(" to "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("calces")]), _vm._v(" and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("vortices; ikon")]), _vm._v(" and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("strophe")]), _vm._v(" tend to prefer "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("ikons")]), _vm._v(" and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("strophes")]), _vm._v(" to "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("ikones")]), _vm._v(" and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("strophai.")]), _vm._v(" Words like "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("proboscis")]), _vm._v(" are particularly difficult: the Greek plural "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("proboscides")]), _vm._v(" seems strange, the English plural "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("proboscises")]), _vm._v(" seems awkward; a common way out (but one which cannot be recommended) is to write "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("probosces,")]), _vm._v(" without any justification either in Greek or in English. Some of the more technical Greek and Latin "), _c('a', {
    attrs: {
      "id": "page_54"
    }
  }), _vm._v("words still retain their irregular plurals: "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("cognomen (cognomina), genus (genera), kore (korai), stoa (stoai).")]), _vm._v(" Expressions involving Latin verbs, which are fortunately rare, may have two different kinds of plural according to the meaning. The distinction is well illustrated by the word "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("exit")]), _vm._v(" ‘(a stage-direction that) he goes out’; if the required meaning in the plural is ‘(stage-directions that) he goes out’ the appropriate form is "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("exits,")]), _vm._v(" but if the required meaning is ‘(a stagedirection that) they go out’ the appropriate form is "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("exeunt.")]), _vm._v(" The majority of such expressions take either one form or the other. Examples of the first type are "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("affidavit (affidavits), caret (carets), cognovit (cognovits")]), _vm._v(") and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("tenet (tenets")]), _vm._v(")"), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/07_Introduction_2#A37",
      "id": "B37"
    }
  }, [_vm._v("1")])]), _vm._v(". Examples of the second type are "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("ipse dixit (ipsi dixerunt), peccavi (peccavimus), proxime accessit (proxime accesserunt).")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In one or two instances the identity of form between the Latin neuter plural in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("-a")]), _vm._v(" and the Latin feminine singular in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("-a")]), _vm._v(" has led to confusion in English: "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("effluvia,")]), _vm._v(" the plural of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("effluvium,")]), _vm._v(" has sometimes been misapprehended as a feminine singular and given a spurious plural "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("effluviæ;")]), _vm._v(" conversely, the feminine singular "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("scoria")]), _vm._v(" has sometimes been misapprehended as a neuter plural and given a spurious singular "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("scorium.")]), _vm._v(" An even more flagrant (though rare) example of this latter error is "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("propaganda")]), _vm._v(" (feminine singular, ablative case), which has occasionally been treated as a plural and supplied with a singular "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("propagandum.")]), _vm._v(" Even when no spurious forms have been invented the misapprehension of a Latin form may be revealed by the structure of the sentence in which it is used; such plural forms as "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("agenda")]), _vm._v(" and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("data")]), _vm._v(" are sometimes erroneously used with singular verbs.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Words from modern languages present fewer difficulties. Words from French are particularly simple, since the normal method of forming the plural in French is by adding an "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("s,")]), _vm._v(" exactly as in English. Works ending in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("-eau,")]), _vm._v(" however, a large number of which have entered English, form their plural in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("-eaux: bureau, château, flambeau, gâteau, morceau, plateau, portmanteau, rouleau, trousseau.")]), _vm._v(" In English these words are often given a plural in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("-s,")]), _vm._v(" but in the more technical contexts a plural in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("-x")]), _vm._v(" is still frequent; however, although the plural "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("-x")]), _vm._v(" is silent in French, it is often sounded as a z in English. Spanish also forms its plural by adding an "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("s")]), _vm._v(" when the singular ends in a vowel, but a little care is needed with Spanish words ending in a consonant: "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("conquistador,")]), _vm._v(" for instance, has plural "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("conquistadores.")]), _vm._v(" German words are usually given German plurals—no other plural for "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Lied")]), _vm._v(" than "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Lieder")]), _vm._v(" is thinkable; but "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Poltergeists")]), _vm._v(" is much commoner than "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Poltergeister.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_55"
    }
  }), _vm._v("Italian words present to a lesser degree the same kind of difficulties as bedevil Latin words. Many Italian masculines in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("-o")]), _vm._v(" regularly take the Italian plural in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("-i: amoretto, bozzetto, contadino, graffito, illuminato, palazzo, pentimento, putto, spolvero,")]), _vm._v(" and many others. Many words of the same type, however, vary between "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("-i")]), _vm._v(" and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("-os: concerto, contralto, impresario, solo, soprano, tempo, torso, virtuoso;")]), _vm._v(" in these cases "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("-i")]), _vm._v(" is preferred in the more technical contexts, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("-os")]), _vm._v(" in the more general contexts"), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/07_Introduction_2#A38",
      "id": "B38"
    }
  }, [_vm._v("1")])]), _vm._v(". The rare Italian masculines in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("-e")]), _vm._v(" (like "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("dilettante")]), _vm._v(") vary between "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("-i")]), _vm._v(" and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("-es.")]), _vm._v(" Masculines in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("-a")]), _vm._v(" (like "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("quadratista")]), _vm._v(" and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("vedutista")]), _vm._v(") always take "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("-i")]), _vm._v(" in the plural. Some Italian feminines in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("-a")]), _vm._v(" regularly form a plural in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("-e: carrozza, fioritura.")]), _vm._v(" Others vary between "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("-e")]), _vm._v(" and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("-as")]), _vm._v(" according to the context: "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("loggia, piazza.")]), _vm._v(" An enlightening example is the word "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("regatta.")]), _vm._v(" This word originally meant, and can still mean, a local contest on the Venetian lagoon, and in this sense the plural is regularly "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("regatte;")]), _vm._v(" but it is more commonly applied to almost any type of aquatic sporting event, and in this sense the plural is "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("regattas.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Phrases from foreign languages may be divided into two general categories according to the way the plural is formed. In the first category only one word, usually the first, is altered in the formation of the plural: "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("amicus curiæ (amici curiæ), chargé d’affaires (chargés d’affaires), desco da parto (deschi da parto), felo de se (felones de se), jeu de mots (jeux de mots), objet d’art (objets d’art).")]), _vm._v(" In the second category, consisting entirely of two-word phrases, both words have to be adjusted in the plural: "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("bel esprit (beaux esprits), corpus vile (corpora vilia), editio princeps (editiones principes), fons vivus (fontes vivi), novus homo (novi homines), tableau vivant (tableaux vivants), varia lectio (variæ lectiones).")]), _vm._v(" A few phrases like "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("hors d’œuvre")]), _vm._v(" remain unchanged in the plural in their language of origin; these generally add an "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("s")]), _vm._v(" in English.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It is possible to summarize the detailed information given in this section without much loss of accuracy. In general it can be said that ‘foreign’ words and phrases form their plurals in English as they do in their languages of origin. However, Latin feminines in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("-a,")]), _vm._v(" most Italian nouns, and French nouns ending in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("-eau")]), _vm._v(" may take either a foreign or an English plural. In these cases a foreign plural is more common in a technical context, an English plural in a nontechnical context; but the correct usage in any given passage is a question which must be left to the linguistic discretion of the writer or speaker.")]), _vm._v(" "), _c('h3', {
    staticClass: "head1",
    attrs: {
      "id": "id29"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_56"
    }
  }), _c('span', {
    staticClass: "bold"
  }, [_vm._v("III. The Arrangement of the Dictionary")])]), _vm._v(" "), _c('h4', {
    staticClass: "head2",
    attrs: {
      "id": "id30"
    }
  }, [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE ALPHABETIC ARRANGEMENT")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The order of the entries in this dictionary is strictly alphabetic. In most dictionaries a strictly alphabetic arrangement of this kind is very properly avoided: groups of related and derived words can most conveniently be discussed under a single heading; idiomatic phrases may need to be discussed under one or more of the most conspicuous words contained in them. Since, however, each ‘foreign’ expression used in English is, as it were, a self-contained entity only very indirectly related to any other, neither of these considerations applies to the present work. A strictly alphabetic sequence is the simplest to consult; moreover, any departure from it would involve ambiguities in the case of expressions like "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("ex tempore")]), _vm._v(" or "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("ex post facto,")]), _vm._v(" sometimes written as a single word and sometimes as two or three, or those like "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("laissez-faire")]), _vm._v(" which are sometimes hyphenated and sometimes not. The characters "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("æ")]), _vm._v(" and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("œ")]), _vm._v(" are alphabetized as "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("ae")]), _vm._v(" and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("oe")]), _vm._v(" respectively. Accent-marks and diacritics of all kinds are ignored in alphabetization, unless two words are distinguished only by the presence or absence of a diacritic; in this case the form without the diacritic comes before the form with the diacritic. Thus, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("comble")]), _vm._v(" comes before "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("comblé, manque")]), _vm._v(" before "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("manqué,")]), _vm._v(" and so on.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Phrases are alphabetized as if they consisted of a continuous string of letters, no account being taken of the spaces between words. Their alphabetic position is always dictated by the first word, unless this is the definite or indefinite article in the language in question; any such article is enclosed in round brackets and ignored in alphabetization, so that ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("le) style, c’est l’homme,")]), _vm._v(" for instance, will be found under "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("S.")]), _vm._v(" This arrangement is rendered necessary by the fact that a number of phrases are used sometimes with and sometimes without a foreign article: "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("le Grand Siècle")]), _vm._v(" and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("la belle époque")]), _vm._v(" may sometimes appear as ‘the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Grand Siècle’")]), _vm._v(" and ‘the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("belle époque’, die neue Sachlichkeit")]), _vm._v(" as ‘the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("neue Sachlichkeit’.")]), _vm._v(" Since, however, the French definite article "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("l")]), _vm._v("’ (used only before a vowel or silent "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("h")]), _vm._v(") is too closely connected with the following word ever to be omitted in this way, an exception is made in this case: "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("l’homme même, for")]), _vm._v(" instance, will be found under "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("L,")]), _vm._v(" not "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("H.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The information given in each entry in the dictionary is arranged in a standard sequence, which is described in the following paragraphs; not all the items described, however, will be found in every entry, since some of them are not always applicable or relevant.")]), _vm._v(" "), _c('h4', {
    staticClass: "head2",
    attrs: {
      "id": "id31"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_57"
    }
  }), _vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE HEAD-WORD")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The head-word (or head-phrase) is given in "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("bold type.")]), _vm._v(" Alternative forms of the head-word are divided by an oblique stroke, the preferable form being given first. Alternative forms which are very rare, or which are clearly erroneous, are mentioned later in the entry. Cross-references to alternative forms are given in the appropriate alphabetic place if this is not immediately adjacent to the main entry, and a brief definition is given there to avoid unnecessary hunting to and fro; if more precise or extensive information is needed it must, of course, be sought under the head-word indicated. There are numerous phrases of which a part is sometimes omitted and sometimes included; in this case the part which is sometimes omitted is enclosed in round brackets. Thus, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("se non è vero, è (molto) ben trovato")]), _vm._v(" implies that the phrase is sometimes found in the form "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("se non è vero, è ben trovato.")]), _vm._v(" Where omissions are very substantial the shortened form is given a separate entry; thus, there is a separate entry for "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("ben trovato,")]), _vm._v(" with a cross-reference to the full form of the phrase. Parts of words omitted when a word or phrase is abbreviated are also enclosed in round brackets, the addition of full stops being taken for granted; thus, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("op(ere) cit(ato")]), _vm._v(") implies an abbreviation "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("op. cit.")]), _vm._v("; the abbreviation is given a cross-reference in the appropriate alphabetic place if this is not immediately adjacent to the main entry. Sometimes it is more convenient to give the abbreviation separately later in the entry; thus, the abbreviation of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("varia lectio")]), _vm._v(" to "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("v.l.")]), _vm._v(" with plural "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("vv.ll.")]), _vm._v(" could not easily be indicated by the use of brackets. Immediately after the head-word, and still in "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("bold type,")]), _vm._v(" come special foreign feminine and plural forms, given in full to avoid any possibility of ambiguity. The mention of a foreign plural at this point does not imply that it is the only, or even the most frequent, plural in use—merely that, if a foreign plural is to be used, this is the correct form"), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/07_Introduction_2#A39",
      "id": "B39"
    }
  }, [_vm._v("1")])]), _vm._v(". If no foreign plural is given the implication is either that no plural is in use, or that the plural is formed according to normal English rules.")]), _vm._v(" "), _c('h4', {
    staticClass: "head2",
    attrs: {
      "id": "id32"
    }
  }, [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE ETYMOLOGY")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The etymology immediately follows the head-word, and is enclosed in square brackets. A full etymology is divided into three parts, but not all of these are always necessary.")]), _vm._v(" "), _c('p', {
    staticClass: "indent5"
  }, [_vm._v("(1) "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("An indication of the language of origin.")]), _vm._v(" I have not attempted full academic accuracy in this indication; I have not attempted, for "), _c('a', {
    attrs: {
      "id": "page_58"
    }
  }), _vm._v("instance, to distinguish between Hindi and Urdu, but have included both under the better known name Hindustani. For the abbreviations used, see "), _c('span', {
    attrs: {
      "href": "#/xhtml/08_Abbreviations#page_62",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("p. 62")]), _vm._v(". In the majority of entries this indication is all that is called for by way of etymology.")]), _vm._v(" "), _c('p', {
    staticClass: "indent5"
  }, [_vm._v("(2) "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The spelling in the language of origin.")]), _vm._v(" If the spelling of a word or phrase in English differs substantially from the spelling in its language of origin, the latter is given in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("italics.")]), _vm._v(" If the language of origin is not written in the Roman alphabet, some standard transliteration is used, except in the case of Greek, which is reproduced in Greek type; this exception is very necessary, since Greek words and phrases are still sometimes printed in English contexts without transliteration. If the language of origin is written in the Roman alphabet the current spelling is used, so that further information can easily be found in a modern dictionary of the language in question. Many English dictionaries still use obsolete spelling-systems when quoting foreign words, so that consultation of a specialist dictionary is made unnecessarily difficult. Turkish, for instance, has officially used the Roman alphabet since as long ago as 1928; yet many English dictionaries still quote Turkish words in an obsolete transliteration of the Arabic script used before 1928. Similarly the spelling of Irish was officially simplified in 1948, and this simplified spelling has been adopted in the present work when Irish words are quoted.")]), _vm._v(" "), _c('p', {
    staticClass: "indent5"
  }, [_vm._v("(3) "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The meaning in the language of origin.")]), _vm._v(" If the literal meaning of the word or phrase differs substantially from the meaning given in the definition and is of some intrinsic interest, it is added at this point, enclosed in inverted commas. The insertion of the literal meaning does not necessarily imply that the figurative meaning current in English is not also current in the language of origin.")]), _vm._v(" "), _c('h4', {
    staticClass: "head2",
    attrs: {
      "id": "id33"
    }
  }, [_vm._v("S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("PECIALIZED AND TECHNICAL USAGE")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("If a word or phrase is a technical term, an indication is given (in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("italics")]), _vm._v(") of the special field of interest to which the expression belongs; for the abbreviations used, see "), _c('span', {
    attrs: {
      "href": "#/xhtml/08_Abbreviations#page_62",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("p. 62")]), _vm._v(". These indications are designedly very general: for instance "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Ling.")]), _vm._v(" ‘Linguistics’ includes not only the technical terms of Linguistics proper but those used in the more technical type of literary criticism and in the study of metre. It is often not possible to define very exactly the boundaries of the fields of study in which a term may be used; but it is important to indicate that it is a specialized term and therefore not in general use, since this fact may influence the extent to which it remains ‘foreign’, and hence its spelling, pronunciation and inflection.")]), _vm._v(" "), _c('h4', {
    staticClass: "head2",
    attrs: {
      "id": "id34"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_59"
    }
  }), _vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE DEFINITION")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The definitions are intended to be as self-contained as possible, and are designed for the enlightenment of those who have little specialized knowledge of the subject concerned; technical accuracy has therefore sometimes been sacrificed to clarity of exposition. Definitions of slightly different senses of the same expression are divided from each other by semicolons; if there are markedly different senses, these are numbered and dealt with separately. Grammatical categories are not defined; if necessary the usage of a word is indicated by the addition of an appropriate context, enclosed in round brackets. Round brackets are also used in another way. Many ‘foreign’ words and phrases are used in English in senses which, though closely related, are not identical with each other, and it is often possible to save space by enclosing part of a definition in round brackets. For instance, the definition of the word "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("trek")]), _vm._v(" runs as follows: ‘(one stage of) a journey by ox-wagon; to make a journey by ox-wagon; (to make) any kind of arduous journey across country.’ Fully expanded, this definition would read as follows: ‘a journey by ox-wagon; one stage of a journey by ox-wagon; to make a journey by ox-wagon; any kind of arduous journey across country; to make any kind of arduous journey across country.’ If the dictionary were intended as an arbiter of usage there might be some ambiguity between the two ways of using round brackets; but, as has been explained above ("), _c('a', {
    attrs: {
      "href": "#/xhtml/06_Introduction_1#page_36"
    }
  }, [_vm._v("p. 36")]), _vm._v("), this is a ‘one-way’ dictionary, designed only to elucidate the meaning of an expression in a given context; no ‘foreign’ expression should be used by a writer or speaker who is in doubt about the limits of permissible usage. Many words used in the definitions which are also head-words in the dictionary are printed in "), _c('span', {
    staticClass: "small"
  }, [_vm._v("SMALL CAPITALS")]), _vm._v(", so that the use of small capitals is equivalent to the addition of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("q.v.")]), _vm._v(" after the word; this device is used only when the consultation of the entry thus referred to will throw further light on the definition.")]), _vm._v(" "), _c('h4', {
    staticClass: "head2",
    attrs: {
      "id": "id35"
    }
  }, [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE DATE OF INTRODUCTION")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("After the definition comes a note of the date at which the word or phrase was introduced into English. Some expressions may have a long history of use in England in contexts other than English contexts (legal terms in Latin or Law-French, for instance); but it is the date of their first appearance in an English context which is given here. The difficulty of establishing the date of first introduction has already been discussed above, "), _c('a', {
    attrs: {
      "href": "#/xhtml/06_Introduction_1#page_25"
    }
  }, [_vm._v("p. 25")]), _vm._v(". The dates are indicated by centuries: "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("16c.")]), _vm._v(" stands for ‘sixteenth century’, and so on. Sometimes different "), _c('a', {
    attrs: {
      "id": "page_60"
    }
  }), _vm._v("senses of the same word or phrase have entered English at different periods; whenever such a difference is interesting or significant the appropriate date is given under each section of the definition.")]), _vm._v(" "), _c('h4', {
    staticClass: "head2",
    attrs: {
      "id": "id36"
    }
  }, [_vm._v("N"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OTES ON POINTS OF INTEREST")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Notes are often added on points of interest arising in connection with the head-words. If the precise connotation of a word or phrase cannot easily be brought out in a concise definition it is elaborated here. Rare or erroneous alternative forms and peculiarities of pronunciation, spelling and usage are discussed, especially in cases which cannot be brought under the general rules given in Section II of this introduction. The notes are also intended to obviate as far as possible the necessity of consulting any other work of reference. Quotations are traced to their origins, though no attempt is made to elucidate dubious attributions. A certain amount of encyclopædic information is provided where it seems likely that the reader’s general knowledge may be at fault; but it is obviously impossible to cater for all classes of users of the dictionary, and there are doubtless many cases where some readers will feel that the explanatory notes labour the obvious, and many cases where other readers will feel that more information would have been welcome.")]), _vm._v(" "), _c('h4', {
    staticClass: "head2",
    attrs: {
      "id": "id37"
    }
  }, [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ROSS-REFERENCES")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("After the notes will be found cross-references, given in "), _c('span', {
    staticClass: "small"
  }, [_vm._v("SMALL CAPITALS")]), _vm._v(", to other words or phrases related by etymology or meaning to the head-word; distinct cross-references are divided from each other by semicolons. It is hoped that these cross-references will be both useful, since they call attention to groups of words and phrases which are nearly but not quite synonymous, and interesting, since they call attention to groups of words having the same ultimate origin but quite different meanings—for instance, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("bodega, bottega")]), _vm._v(" and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("boutique,")]), _vm._v(" etymologically identical, have wholly different connotations in English.")]), _vm._v(" "), _c('h4', {
    staticClass: "head2",
    attrs: {
      "id": "id38"
    }
  }, [_vm._v("I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("LLUSTRATIVE QUOTATIONS")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The plan of the dictionary does not allow for the inclusion of quotations illustrating ‘foreign’ words and phrases in English; such quotations would have increased the bulk and the cost of the work enormously. However, each entry ends with an indication (enclosed in square brackets) of the places where illustrative quotations may be "), _c('a', {
    attrs: {
      "id": "page_61"
    }
  }), _vm._v("found. References are to "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("A New English Dictionary on Historical Principles")]), _vm._v(" (1884–1928; Supplement 1933)"), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/07_Introduction_2#A40",
      "id": "B40"
    }
  }, [_vm._v("1")])]), _vm._v(" and to "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Stanford Dictionary of Anglicised Words and Phrases")]), _vm._v(" (1892; Supplement of the same date). The abbreviations used are the following:")]), _vm._v(" "), _c('table', {
    staticClass: "tab1"
  }, [_c('tbody', [_c('tr', [_c('td', [_c('p', {
    staticClass: "ttext"
  }, [_vm._v("N")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "ttext"
  }, [_vm._v("New English Dictionary")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "ttext"
  }, [_vm._v("N*")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "ttext"
  }, [_vm._v("New English Dictionary (Supplement)")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "ttext"
  }, [_vm._v("N(*)")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "ttext"
  }, [_vm._v("New English Dictionary and Supplement")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "ttext"
  }, [_vm._v("S")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "ttext"
  }, [_vm._v("Stanford")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "ttext"
  }, [_vm._v("S*")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "ttext"
  }, [_vm._v("Stanford (Supplement)")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "ttext"
  }, [_vm._v("S(*)")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "ttext"
  }, [_vm._v("Stanford and Supplement")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("This dictionary thus serves as an index to those ‘foreign’ words and phrases in the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("New English Dictionary")]), _vm._v(" and in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Stanford")]), _vm._v(" which are still current.")]), _vm._v(" "), _c('p', {
    staticClass: "foot1"
  }, [_c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/05_Introduction#B1",
      "id": "A1"
    }
  }, [_vm._v("1")])]), _vm._v(" For further details of this important work see "), _c('a', {
    attrs: {
      "href": "#/xhtml/07_Introduction_2#page_61"
    }
  }, [_vm._v("p. 61")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/05_Introduction#B2",
      "id": "A2"
    }
  }, [_vm._v("1")])]), _vm._v(" For further details of this work see "), _c('a', {
    attrs: {
      "href": "#/xhtml/07_Introduction_2#page_61"
    }
  }, [_vm._v("p. 61")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/05_Introduction#B3",
      "id": "A3"
    }
  }, [_vm._v("1")])]), _vm._v(" Half the words as listed in a dictionary or glossary, that is; in a passage of continuous writing not more than one fifth of the words would be of foreign origin, because the foreign words were used relatively much less frequently than the surviving native words.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/05_Introduction#B4",
      "id": "A4"
    }
  }, [_vm._v("1")])]), _vm._v(" The pronunciation of Latin and Greek in England is discussed at length below, "), _c('a', {
    attrs: {
      "href": "#/xhtml/06_Introduction_1#page_37"
    }
  }, [_vm._v("pp. 37")]), _vm._v("–"), _c('a', {
    attrs: {
      "href": "#/xhtml/06_Introduction_1#page_40"
    }
  }, [_vm._v("40")]), _vm._v(" and "), _c('a', {
    attrs: {
      "href": "#/xhtml/06_Introduction_1#page_42"
    }
  }, [_vm._v("42")]), _vm._v("–"), _c('a', {
    attrs: {
      "href": "#/xhtml/06_Introduction_1#page_44"
    }
  }, [_vm._v("44")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/05_Introduction#B5",
      "id": "A5"
    }
  }, [_vm._v("1")])]), _vm._v(" The ending "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("-ous")]), _vm._v(" is a Norman dialect form corresponding to the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("-eux")]), _vm._v(" of standard French: "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("fameux, généreux.")])]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/05_Introduction#B6",
      "id": "A6"
    }
  }, [_vm._v("1")])]), _vm._v(" The dictionary also, of course, deals with foreign phrases; but these are normally anglicized (if at all) by translation, and therefore present fewer problems; see below, "), _c('a', {
    attrs: {
      "href": "#/xhtml/05_Introduction#page_22"
    }
  }, [_vm._v("pp. 22")]), _vm._v("–"), _c('a', {
    attrs: {
      "href": "#/xhtml/06_Introduction_1#page_23"
    }
  }, [_vm._v("23")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/05_Introduction#B7",
      "id": "A7"
    }
  }, [_vm._v("1")])]), _vm._v(" Current usage as it affects accent-marks and other diacritics is discussed at greater length below, "), _c('a', {
    attrs: {
      "href": "#/xhtml/07_Introduction_2#page_46"
    }
  }, [_vm._v("pp. 46")]), _vm._v("–"), _c('a', {
    attrs: {
      "href": "#/xhtml/07_Introduction_2#page_48"
    }
  }, [_vm._v("48")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/05_Introduction#B8",
      "id": "A8"
    }
  }, [_vm._v("2")])]), _vm._v(" Under this heading might be included the occurrence of a stress which would not seem natural in a native English word. But usage is too variable for this consideration to be of much value: such words as "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("bureau")]), _vm._v(" and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("garage")]), _vm._v(" can be heard stressed on either syllable.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/05_Introduction#B9",
      "id": "A9"
    }
  }, [_vm._v("1")])]), _vm._v(" The plural "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("s")]), _vm._v(" is normally not pronounced in French, so that failure to pronounce it might be considered an indication that the word concerned is ‘foreign’; unfortunately the plural "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("s")]), _vm._v(" is often pronounced in English even when added to unmistakably ‘foreign’ nouns like "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("trait;")]), _vm._v(" the normal pronunciation of the plural "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("traits")]), _vm._v(" is like "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("trays,")]), _vm._v(" a pronunciation which is neither fully English nor fully French. The word "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("corps")]), _vm._v(" has the same spelling in both singular and plural, in English as in French; the final "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("-s")]), _vm._v(" is always silent in French, but in English it is pronounced in the plural, though not in the singular.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/05_Introduction#B10",
      "id": "A10"
    }
  }, [_vm._v("1")])]), _vm._v(" Current usage in respect of foreign feminines and plurals is discussed at greater length below, "), _c('a', {
    attrs: {
      "href": "#/xhtml/07_Introduction_2#page_51"
    }
  }, [_vm._v("pp. 51")]), _vm._v("–"), _c('a', {
    attrs: {
      "href": "#/xhtml/07_Introduction_2#page_55"
    }
  }, [_vm._v("55")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/05_Introduction#B11",
      "id": "A11"
    }
  }, [_vm._v("1")])]), _vm._v(" For some further possible examples of this tendency see below, "), _c('a', {
    attrs: {
      "href": "#/xhtml/07_Introduction_2#page_48"
    }
  }, [_vm._v("p. 48")]), _vm._v(". The final "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("-e")]), _vm._v(" of the word "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("forte")]), _vm._v(" (French "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("fort")]), _vm._v(") may be intended to distinguish it from the military term "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("fort,")]), _vm._v(" though here no question of stress arises.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/05_Introduction#B12",
      "id": "A12"
    }
  }, [_vm._v("1")])]), _vm._v(" The adaptation of quotations is discussed at greater length below, "), _c('a', {
    attrs: {
      "href": "#/xhtml/06_Introduction_1#page_30"
    }
  }, [_vm._v("pp. 30")]), _vm._v("–"), _c('a', {
    attrs: {
      "href": "#/xhtml/06_Introduction_1#page_32"
    }
  }, [_vm._v("32")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/05_Introduction#B13",
      "id": "A13"
    }
  }, [_vm._v("1")])]), _vm._v(" The alternative term for this quality is German: "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Gemeinschaftsgefühl.")])]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/05_Introduction#B14",
      "id": "A14"
    }
  }, [_vm._v("1")])]), _vm._v(" In fact the word exists in the language in an anglicized form: English "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("wicket,")]), _vm._v(" anglicized in the thirteenth century, represents a Norman dialect form of French "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("guichet.")]), _vm._v(" In the sense ‘small door in a large door’ it retains the sense ‘opening’; in the sense ‘set of stumps and bails in cricket’ it retains the sense ‘grill’.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/06_Introduction_1#B15",
      "id": "A15"
    }
  }, [_vm._v("1")])]), _vm._v(" A special form of anglicization, in which a foreign phrase is anglicized as a single word, is illustrated by the word "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("paramour,")]), _vm._v(" from the French phrase "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("par amour")]), _vm._v(" ‘by way of love’. French "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("débonnaire,")]), _vm._v(" though it has now been re-adopted as a ‘foreign’ word, was fully anglicized as early as the thirteenth century; but this is not really an example of the anglicization of a phrase, since "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("de bonne aire")]), _vm._v(" had already become a single word in French before it was introduced into English.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/06_Introduction_1#B16",
      "id": "A16"
    }
  }, [_vm._v("1")])]), _vm._v(" For further details of these works see "), _c('a', {
    attrs: {
      "href": "#/xhtml/07_Introduction_2#page_61"
    }
  }, [_vm._v("p. 61")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/06_Introduction_1#B17",
      "id": "A17"
    }
  }, [_vm._v("1")])]), _vm._v(" For a scathing denunciation of this kind of vulgarity see H. W. Fowler "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("A Dictionary of Modern English Usage")]), _vm._v(" (1926) s.v. "), _c('span', {
    staticClass: "small"
  }, [_vm._v("FRENCH WORDS")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/06_Introduction_1#B18",
      "id": "A18"
    }
  }, [_vm._v("1")])]), _vm._v(" The vowels of German and Dutch underwent a similar series of changes; but in these languages the spelling was altered to correspond with the new pronunciation, so that the value of each vowel-symbol remained unaltered.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/06_Introduction_1#B19",
      "id": "A19"
    }
  }, [_vm._v("1")])]), _vm._v(" Before 1850 the Roman clergy in England had used a compromise pronunciation, the origin of which is disputable, combining ‘Italian’ vowels with ‘English’ consonants; for some time after 1850 the pronunciation of Latin in the ‘Italian’ style was one of numerous bones of contention between the pre-Emancipation clergy and the new ultramontane hierarchy. The Society of Jesus in England still makes use of a pronunication resembling the old compromise pronunciation.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/06_Introduction_1#B20",
      "id": "A20"
    }
  }, [_vm._v("2")])]), _vm._v(" Before "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("e")]), _vm._v(" and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("i")]), _vm._v(" Latin "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("c")]), _vm._v(" and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("g")]), _vm._v(" are pronounced like English "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("s")]), _vm._v(" and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("j")]), _vm._v(" in the ‘English’ system, like English "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("ch")]), _vm._v(" and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("j")]), _vm._v(" in the ‘Italian’ system.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/06_Introduction_1#B21",
      "id": "A21"
    }
  }, [_vm._v("1")])]), _vm._v(" In Ireland such common words and phrases as "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("a priori, data, status,")]), _vm._v(" etc. are often pronounced with ‘Italian’ vowels even by educated people, doubtless because of their familiarity with ecclesiastical Latin.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/06_Introduction_1#B22",
      "id": "A22"
    }
  }, [_vm._v("1")])]), _vm._v(" The Roman transliteration is not always always wholly self-consistent. The rendering of Greek "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("καρίκ∊ιον")]), _vm._v(" as "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("caduceus,")]), _vm._v(" for instance, is eccentric in a number of ways.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/06_Introduction_1#B23",
      "id": "A23"
    }
  }, [_vm._v("2")])]), _vm._v(" Not every Latin "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("-us")]), _vm._v(" in a word of Greek origin is from "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("-os.")]), _vm._v(" Latin "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("periplus")]), _vm._v(" is from Greek "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("π∊ρίπλους.")]), _vm._v(" Latin "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("polypus,")]), _vm._v(" from Greek "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("πολύπους,")]), _vm._v(" exceptionally has a plural "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("polypi")]), _vm._v(" as if the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("-us")]), _vm._v(" were indeed from "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("-os.")]), _vm._v(" The "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("-os")]), _vm._v(" in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("tripos")]), _vm._v(" is a spurious Greek form based on the Latin "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("tripus")]), _vm._v(" from Greek "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("τρίπους.")])]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/06_Introduction_1#B24",
      "id": "A24"
    }
  }, [_vm._v("3")])]), _vm._v(" The ending "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("-on")]), _vm._v(" in Latin words of Greek origin is sometimes from Greek "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("-ωv,")]), _vm._v(" as in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("cacodæmon, colophon, dæmon;")]), _vm._v(" this "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("-on")]), _vm._v(" is naturally never at any period replaced by "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("-um.")])]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/06_Introduction_1#B25",
      "id": "A25"
    }
  }, [_vm._v("1")])]), _vm._v(" Already in the eighteenth century the form "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("homoousion")]), _vm._v(" had been used by Gibbon, a man of exceptional learning. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Noumenon")]), _vm._v(" is not a relevant example, since the Greek form has "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("ooυ")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/06_Introduction_1#B26",
      "id": "A26"
    }
  }, [_vm._v("2")])]), _vm._v(" A very early example of the use of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("k")]), _vm._v(" is "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("kyrie eleison")]), _vm._v(" (fourteenth century).")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/06_Introduction_1#B27",
      "id": "A27"
    }
  }, [_vm._v("1")])]), _vm._v(" This pronunciation has had a chequered history. As early as the sixteenth century attempts to reform the pronunciation of Greek led to high feelings and ecclesiastical censure.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/06_Introduction_1#B28",
      "id": "A28"
    }
  }, [_vm._v("2")])]), _vm._v(" It is possible, even probable, that the accent-marks were intended to record a ‘pitch-accent’ rather than a ‘stress-accent’ in ancient Greek; i.e. that the accent consisted rather of a change of pitch than of an increase in intensity as in modern English. If so, the pitch-accent of ancient Greek has been replaced by stress-accent in Modern Greek.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/07_Introduction_2#B29",
      "id": "A29"
    }
  }, [_vm._v("1")])]), _vm._v(" However, English "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("s(t)ch")]), _vm._v(" does not always correspond to the Russian "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("shch;")]), _vm._v(" English "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("izvoschik")]), _vm._v(" is from Russian "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("izvozchik.")])]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/07_Introduction_2#B30",
      "id": "A30"
    }
  }, [_vm._v("1")])]), _vm._v(" In fact a different word has been substituted for the second element: French "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("courrier")]), _vm._v(" (from Italian "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("corriere")]), _vm._v(") is distinct from French "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("coureur,")]), _vm._v(" but some of the meanings of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("coureur")]), _vm._v(" have been taken over by the anglicized "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("courier.")])]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/07_Introduction_2#B31",
      "id": "A31"
    }
  }, [_vm._v("2")])]), _vm._v(" English usage in the writing and printing of German nouns is far from stable. In German all nouns normally take a capital letter, and this custom is often followed when German nouns are used in English; but the capital is sometimes omitted in accordance with normal English usage. In this dictionary all German nouns are printed with a capital letter.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/07_Introduction_2#B32",
      "id": "A32"
    }
  }, [_vm._v("1")])]), _vm._v(" In writing by hand or with a typewriter an accent-mark can be added without difficulty to the ordinary symbol; but, in printing, each combination of symbol and accent-mark has to be individually cast, and these special types have to be separately stored. Where mechanical setting by Linotype is used the number of types available is limited by the structure of the Linotype machine, and it is not possible (as it is with mechanical setting by Monotype) to insert special characters later by hand.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/07_Introduction_2#B33",
      "id": "A33"
    }
  }, [_vm._v("1")])]), _vm._v(" Some of these errors may be due to erroneous associations with other words: "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("chalet")]), _vm._v(" with "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("château, chenet")]), _vm._v(" with "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("chêne, coterie")]), _vm._v(" with "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("côte, roturier")]), _vm._v(" with "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("rôtir.")])]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/07_Introduction_2#B34",
      "id": "A34"
    }
  }, [_vm._v("2")])]), _vm._v(" The omission of the acute accent at the end of a word is much more common in the United States, where words like "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("canapé")]), _vm._v(" and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("coupé")]), _vm._v(" are often written "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("canape")]), _vm._v(" and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("coupe;")]), _vm._v(" the omission is sometimes accompanied by a corresponding change in the pronunciation.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/07_Introduction_2#B35",
      "id": "A35"
    }
  }, [_vm._v("1")])]), _vm._v(" There are minor differences between English and other languages in the articulation of nearly all sounds, consonants as well as vowels. These need not be listed here, but reinforce the argument of the next paragraph.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/07_Introduction_2#B36",
      "id": "A36"
    }
  }, [_vm._v("2")])]), _vm._v(" In printing, of course, a ‘foreign’ expression can easily be distinguished as such by the use of italics.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/07_Introduction_2#B37",
      "id": "A37"
    }
  }, [_vm._v("1")])]), _vm._v(" The plural "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("tenent")]), _vm._v(" was formerly in use but is now obsolete.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/07_Introduction_2#B38",
      "id": "A38"
    }
  }, [_vm._v("1")])]), _vm._v(" The ending "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("-oes")]), _vm._v(" is appropriate only when a word is fully anglicized, and forms like "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("soloes")]), _vm._v(" are better avoided.")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/07_Introduction_2#B39",
      "id": "A39"
    }
  }, [_vm._v("1")])]), _vm._v(" The use of foreign plurals has been discussed above, "), _c('a', {
    attrs: {
      "href": "#/xhtml/07_Introduction_2#page_52"
    }
  }, [_vm._v("pp. 52")]), _vm._v("–"), _c('a', {
    attrs: {
      "href": "#/xhtml/07_Introduction_2#page_55"
    }
  }, [_vm._v("55")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/07_Introduction_2#B40",
      "id": "A40"
    }
  }, [_vm._v("1")])]), _vm._v(" This work was re-issued by the Clarendon Press in 1933 as "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Oxford English Dictionary.")]), _vm._v(" The majority of writers on language continue to use the original name, partly to ensure conformity with the universal practice before 1933, partly to avoid confusion with the other Oxford dictionaries—"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Shorter Oxford English Dictionary, The Concise Oxford Dictionary,")]), _vm._v(" and others.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-75be4437","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/07_Introduction_2.vue
// module id = 84
// module chunks = 0